module.exports = __webpack_public_path__ + "img/mm.06b632f7.png";